(function () {
  function init(root) {
    var track = root.querySelector(".gb-ships-now__track");
    if (!track) return;
    var speed = 1.4, paused = false, half = 0, resumeTimer = null, visible = false, raf = 0, pos = 0;
    var reduce = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    function measure() { half = track.scrollWidth / 2; }
    measure();
    window.addEventListener("load", measure);
    window.addEventListener("resize", measure);
    setTimeout(measure, 800);
    /* g92 (17 Oct 2026): no read-after-write per frame, and no loop while the marquee is off screen, the tab is hidden, the user is touching it or motion is reduced */
    function tick() {
      raf = 0;
      if (paused || !visible || document.hidden || reduce || half <= 0) return;
      pos += speed;
      if (pos >= half) pos -= half;
      root.scrollLeft = pos;
      raf = requestAnimationFrame(tick);
    }
    function start() {
      if (raf || !visible || paused || reduce || half <= 0 || document.hidden) return;
      pos = root.scrollLeft;
      raf = requestAnimationFrame(tick);
    }
    function pause() { paused = true; if (resumeTimer) { clearTimeout(resumeTimer); resumeTimer = null; } }
    function resume() { paused = false; start(); }
    function resumeSoon() { if (resumeTimer) clearTimeout(resumeTimer); resumeTimer = setTimeout(function () { resumeTimer = null; resume(); }, 1500); }
    root.addEventListener("mouseenter", pause);
    root.addEventListener("mouseleave", resume);
    root.addEventListener("touchstart", pause, { passive: true });
    root.addEventListener("touchend", resumeSoon, { passive: true });
    root.addEventListener("pointerdown", pause);
    window.addEventListener("pointerup", resumeSoon);
    document.addEventListener("visibilitychange", start);
    if ("IntersectionObserver" in window) {
      new IntersectionObserver(function (entries) { visible = entries[entries.length - 1].isIntersecting; if (visible) start(); }, { threshold: 0 }).observe(root);
    } else { visible = true; start(); }
  }
  function boot() { Array.prototype.forEach.call(document.querySelectorAll(".gb-ships-now__marquee"), init); }
  document.readyState !== "loading" ? boot() : document.addEventListener("DOMContentLoaded", boot);
})();
